module.exports = __webpack_public_path__ + "static/media/P9.e059c6a5.png";